import { HandleSendUnsafeReceiveHelperBase } from './HandleSendUnsafeReceiveHelperBase';
export class HandleReceiveHelper extends HandleSendUnsafeReceiveHelperBase {
    constructor() {
        super(...arguments);
        this.lessThan = false;
    }
}

//# sourceMappingURL=HandleReceiveHelper.js.map
